'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function generateComputedMode(mode) {
    return {
        get: function computedModeGet() {
            return this.modeVal(mode);
        },
        set: function computedModeSet(newVal) {
            return this.setMode((newVal ? '+' : '-') + mode);
        }
    };
}

function generateComputedModeWithParam(mode) {
    return {
        get: function computedModeWithParamGet() {
            var val = this.modeVal(mode);
            return val === false ? '' : val;
        },
        set: function computedModeWithParamSet(newVal) {
            if (newVal) {
                this.setMode('+' + mode, newVal);
            } else {
                this.setMode('-' + mode);
            }
        }
    };
}

exports.default = {
    props: ['buffer'],
    data: function data() {
        return {
            showPrevTopics: false
        };
    },
    computed: {
        modeM: generateComputedMode('m'),
        modeI: generateComputedMode('i'),
        modeT: generateComputedMode('t'),
        modeN: generateComputedMode('n'),
        modeK: generateComputedModeWithParam('k'),
        topic: {
            get: function computedTopicGet() {
                return this.buffer.topic;
            },
            set: function computedTopicSet(newVal) {
                var newTopic = newVal.replace('\n', ' ');
                this.buffer.getNetwork().ircClient.setTopic(this.buffer.name, newTopic);
            }
        }
    },
    methods: {
        updateBanList: function updateBanList() {
            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, '+b');
        },
        setMode: function setMode(mode, param) {
            this.buffer.getNetwork().ircClient.raw('MODE', this.buffer.name, mode, param);
        },
        modeVal: function modeVal(mode) {
            var val = false;

            if (typeof this.buffer.modes[mode] === 'undefined') {
                val = false;
            } else if (!this.buffer.modes[mode]) {
                val = true;
            } else {
                val = this.buffer.modes[mode];
            }

            return val;
        },
        areWeAnOp: function areWeAnOp() {
            return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["ChannelInfo"]
window._kiwi_exports.components.ChannelInfo = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChannelInfo.vue
// module id = ZofN
// module chunks = 1